
import { defineComponent, nextTick, PropType, ref, watch } from "vue";
import { ElCol, ElForm, ElFormItem, ElRow } from 'element-plus'
import ElSelectExt from '@/components/ElSelectExt.vue'
import ElTableExt from '@/components/ElTableExt.vue'
import DynamicJsonForm from '@/components/DynamicJsonForm.vue'

const componentMap: any = {
  ElSelectExt,
  ElTableExt,
  DynamicJsonForm
}

export default defineComponent({
  name: 'DynamicForm',
  components: {
    ElForm,
    ElFormItem,
    ElRow,
    ElCol
  },
  props: {
    model: {
      type: Object as PropType<Record<string, any>>,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: -1
    },
    labelWidth: {
      type: String,
      default: '120px'
    },
    rows: {
      type: Array as PropType<any[][]>,
      required: true
    },
    columns: {
      type: Array as PropType<any[]>,
      required: true,
    },
    roleIds: {
      type: Array as PropType<number[]>,
      required: true
    },
    gutter: {
      type: Number,
      default: 20
    },
    justify: {
      type: String,
      default: 'space-between'
    },
    colSpan: {
      type: Number,
      default: 8
    }
  },
  emits: ['update:model'],
  setup(props, { emit }) {
    const formModel = ref({ ...props.model })
    //const currentRows = ref([ ... props.rows])
    const formRef = ref<InstanceType<typeof ElForm> | null>(null)


    watch(
      formModel,
      (newModel) => {
        if (newModel) {
          if (props.index == -1) {
            handleUpdate(newModel)
          } else {
            handleUpdate(newModel, props.index)
          }
        }
      },
      { deep: true, immediate: false }
    )

    const formatRules = (item: any) => {
      if(props.roleIds.indexOf(item.oprRoles) !== -1 && props.canEdit){
        const result = JSON.parse(item.componentOptions)
        if (result) {
          result.type = result.searchType
          return result.rules ? result.rules : []
        } else {
          return []
        }
      } else {
        return []
      }
    }

    const validateForm = () => {
      return new Promise((resolve, reject) => {
        formRef.value?.validate((valid: any) => {
          if (valid) {
            resolve(true)
          } else {
            nextTick(() => {
              const errorEl: any = document.querySelector('.el-form-item__error')
              if (errorEl) {
                scrollToError(errorEl)
              }
            })
            reject(false)
          }
        })
      })
    }

    const scrollToError = (el: HTMLElement) => {
      el.scrollIntoView({ behavior: 'smooth' });
    }

    const getComponent = (item: any) => {
      const componentName = item.component
      const component = componentMap[componentName]
      if (!component) {
        return componentName
      }
      return component
    }

    const isFullRow = (item: any) => {
      return (
        item.component === 'DynamicJsonForm' ||
        item.component === 'ElTableExt' ||
        item.columnFormat === 'fitLine'
      )
    }

    const handleUpdateJson = (value: String, field: any) => {
       formModel.value[field] = value
    }

    const formatOptions = (item: any) => {
      return JSON.parse(item.componentOptions)
    }

    const formatViewValue = (item: any) => {
      if(formModel.value[item.columnName]) {
        const result = JSON.parse(item.componentOptions)
        if (result && result.format) {
          return result.options.find((o: any) => o.value == formModel.value[item.columnName])?.label
        } else {
          if(formModel.value[item.columnName] instanceof Array) {
            return formModel.value[item.columnName].join('+')
          } else {
            return formModel.value[item.columnName]
          }
        }
      } else {
        return '暂无数据'
      }
    }

    const handleUpdate = (value: Record<string, any>, index?: number) => {
      emit('update:model', value, index)
    }

    return {
      formRef,
      formModel,
      formatRules,
      getComponent,
      isFullRow,
      formatOptions,
      formatViewValue,
      handleUpdate,
      scrollToError,
      validateForm,
      handleUpdateJson
    }
  }
})
